import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { History, Loader2, RotateCcw } from 'lucide-react';

const eur = (v) => (parseFloat(v) || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
const dateFr = (d) => (d ? new Date(d).toLocaleDateString('fr-FR') : '-');

// Liste des échéances supprimées avec restauration (statut d'origine conservé)
export const EcheancesSupprimees = ({ listUrl, restoreUrl, restoreAllUrl, headers, onDone, testId, dateKey = 'date', refreshKey }) => {
  const [data, setData] = useState({ echeances: [], echeancier_complet: null });
  const [busy, setBusy] = useState(null);

  const charger = useCallback(async () => {
    try { const res = await axios.get(listUrl, { headers }); setData({ echeances: res.data.echeances || [], echeancier_complet: res.data.echeancier_complet || null }); }
    catch { setData({ echeances: [], echeancier_complet: null }); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listUrl]);

  useEffect(() => { charger(); }, [charger, refreshKey]);

  const restaurer = async (url, cle, libelle) => {
    if (!window.confirm(`Restaurer ${libelle} ?\n\nLe reçu sera régénéré.`)) return;
    setBusy(cle);
    try {
      const res = await axios.post(url, {}, { headers });
      toast.success(res.data?.message || 'Restauré');
      await charger();
      await onDone?.();
    } catch (e) { toast.error(e.response?.data?.detail || 'Restauration impossible'); }
    finally { setBusy(null); }
  };

  if (!data.echeances.length && !data.echeancier_complet) return null;
  return (
    <div className="mt-2 rounded-lg border border-slate-200 bg-slate-50 p-2" data-testid={testId}>
      <p className="text-xs font-semibold text-slate-700 mb-1 flex items-center gap-1"><History className="h-3.5 w-3.5" /> Échéances supprimées</p>
      {data.echeancier_complet && (
        <div className="flex items-center gap-2 text-xs mb-1">
          <span className="flex-1">Échéancier complet ({data.echeancier_complet.nb} échéances) supprimé le {dateFr(data.echeancier_complet.supprime_at)}</span>
          <button type="button" onClick={() => restaurer(restoreAllUrl, 'tout', "tout l'échéancier")} disabled={busy === 'tout'}
            className="inline-flex items-center gap-1 text-indigo-700 hover:text-indigo-900 disabled:opacity-50" data-testid={`${testId}-restaurer-tout`}>
            {busy === 'tout' ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <RotateCcw className="h-3.5 w-3.5" />} Restaurer
          </button>
        </div>
      )}
      {data.echeances.map((t) => {
        const cle = t.trace_id || t.id;
        const payee = t.paye || t.statut === 'paye';
        return (
          <div key={cle} className="flex items-center gap-2 text-xs" data-testid={`${testId}-ligne-${cle}`}>
            <span className="w-20">{dateFr(t[dateKey])}</span>
            <span className="flex-1 font-medium">{eur(t.montant)} {payee && <span className="text-emerald-700">(payée)</span>}</span>
            <span className="text-slate-400 hidden sm:inline">supprimée le {dateFr(t.supprime_at)}</span>
            <button type="button" onClick={() => restaurer(restoreUrl(t), cle, `l'échéance de ${eur(t.montant)}`)} disabled={busy === cle}
              className="inline-flex items-center gap-1 text-indigo-700 hover:text-indigo-900 disabled:opacity-50" data-testid={`${testId}-restaurer-${cle}`}>
              {busy === cle ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <RotateCcw className="h-3.5 w-3.5" />} Restaurer
            </button>
          </div>
        );
      })}
    </div>
  );
};
